<!-- 
Contents of the DETAIL tab of the invoice page.
-->
<template>
  <div>
    <our-heading 
      :next-page-action="nextPageAction"
      :previous-page-action="previousPageAction"
      :breadcrumbs="breadcrumbs"
      :title="title"
      :subtitle="subtitle"
      :nav-url="getNavUrl('detail')"
      arrived-from-listing
      user-guide-topic="levy-collection-invoices"
      module="invoices"
    >
      <template v-if="arrivedFromLevyCollection" v-slot:navigator>
        <levy-collection-navigator :levy-collection-id="levyCollectionId" />
      </template>
    </our-heading>
    <tabs :invoice-id="invoiceId" :levy-collection-id="invoice.levyCollectionId" :provider-id="invoice.providerId" path="detail">
      <invoice-detail-panel :invoice-id="invoiceId"/>
    </tabs>
  </div>
</template>

<script>
import InvoiceDetailPanel from "@/components/invoices/InvoiceDetailPanel.vue";
import LevyCollectionNavigator from "@/components/levy-collections/LevyCollectionNavigator.vue";
import Tabs from "./Tabs.vue";
import invoiceMixins from "./mixins";

export default {
  name: "InvoiceDetail",
  components: { InvoiceDetailPanel, LevyCollectionNavigator, Tabs },
  mixins: [invoiceMixins]
};
</script>
